// extracted by mini-css-extract-plugin
module.exports = {"container":"KquLJ","playerThere":"_3xaw6","fullScreenView":"_3eQC4","shrinkScreen":"_3lsNS"};